/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S9_Li1Inputs */

const tr_onbilgi_s9_li1 = /** @type {(inputs: Onbilgi_S9_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Hakem Heyetleri (Ticaret Bakanlığı tarafından her yıl ilan edilen parasal sınırlar dahilinde).`)
};

const en_onbilgi_s9_li1 = /** @type {(inputs: Onbilgi_S9_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Hakem Heyetleri (within the monetary limits announced each year by the Ticaret Bakanlığı).`)
};

const de_onbilgi_s9_li1 = /** @type {(inputs: Onbilgi_S9_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Hakem Heyetleri (innerhalb der vom Ticaret Bakanlığı jährlich bekannt gegebenen Wertgrenzen).`)
};

const ru_onbilgi_s9_li1 = /** @type {(inputs: Onbilgi_S9_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Hakem Heyetleri (в пределах денежных лимитов, ежегодно объявляемых Ticaret Bakanlığı).`)
};

/**
* | output |
* | --- |
* | "Tüketici Hakem Heyetleri (within the monetary limits announced each year by the Ticaret Bakanlığı)." |
*
* @param {Onbilgi_S9_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s9_li1 = /** @type {((inputs?: Onbilgi_S9_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S9_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s9_li1(inputs)
	if (locale === "de") return de_onbilgi_s9_li1(inputs)
	if (locale === "ru") return ru_onbilgi_s9_li1(inputs)
	return tr_onbilgi_s9_li1(inputs)
});